import React, { useRef, useState, useEffect } from 'react';
import styles from '../authentic_barbearia1/authentic_barbearia1.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Authentic_barbearia1: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [heightImg, setHeightImg] = useState<number>(0);
    const [distanceToTop, setDistanceToTop] = useState<number>(0);

    useEffect(() => {
        if (imgRef.current) {
            const { top, height } = imgRef.current.getBoundingClientRect();
            let heightImg = (top + (height / 2));
            let distanceToTop = height < 200 ? 200 - heightImg : 0;
            setHeightImg(heightImg < 200 ? 200 : heightImg);
            setDistanceToTop(distanceToTop < 0 ? 0 : distanceToTop);
        }
    }, []);

    return (
        <div className={styles.authentic_barbearia1}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: heightImg == 0 ? "0px" : heightImg + "px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} style={{ top: distanceToTop }}>
                    <img
                        ref={imgRef}
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>AUTHENTIC BARBEARIA 💈</h1>
                    <p>BARBA | CABELO | BIGODE</p>
                    <div className={styles.links}>
                        <Link
                            href="https://www.instagram.com/authentic_barbearia1?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon color="#ffffff" height="32" />}
                            backgroundColor="#000"
                            backgroundColorHover="#424242"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://wa.me/5517988135850?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20horário."
                            title="Whatsapp"
                            icon={<WhatsappIcon color="#ffffff" height="40" />}
                            backgroundColor="#000"
                            backgroundColorHover="#424242"
                            colorText="#ffffff"
                        />
                        <Link
                            href="#"
                            title="Catálogo"
                            icon={<CatalogIcon color="#ffffff" height="35" />}
                            backgroundColor="#000"
                            backgroundColorHover="#424242"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://maps.app.goo.gl/RcAWDSFbbg5iFj2RA"
                            title="Localização"
                            icon={<MapsIcon color="#ffffff" height="40" />}
                            backgroundColor="#000"
                            backgroundColorHover="#424242"
                            colorText="#ffffff"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Authentic_barbearia1;
